import { type FunctionComponent } from "react";

import { BaseLink } from "~/components/common/base-link";
import { staticPathname as storyStyleStaticPathname } from "~/pages/story-style";

import { Container, ContentContainer, ExploreNow, Headline, Text } from "./styles";

type Props = {
  className?: string;
  sectionPathName?: string;
};

export const StoryCardCarouselWidgetDisplayHeading: FunctionComponent<Props> = ({
  className,
  sectionPathName,
}) => (
  <Container className={className}>
    <ContentContainer>
      <Headline>STYLE STORIES</Headline>
      <Text>Your quintessential guide to luxury reimagined.</Text>
    </ContentContainer>
    <BaseLink
      pathname={`${storyStyleStaticPathname}/${sectionPathName}`}
      query={{
        origin: window.location.href,
      }}
    >
      <ExploreNow>EXPLORE NOW</ExploreNow>
    </BaseLink>
  </Container>
);

StoryCardCarouselWidgetDisplayHeading.displayName = "StoryCardCarouselWidgetDisplayHeading";
